import {triggerToast} from 'helpers';

// Global error handler for uncaught JavaScript errors
const handleUncaughtError = (event) => {
  console.error('Uncaught error:', event.error);

  // Show user-friendly error message
  triggerToast.error('An unexpected error occurred. Please try again.');

  // You can log to an error reporting service here
  // Example: logErrorToService(event.error, { type: 'uncaught' });

  // Prevent the default browser error handling
  event.preventDefault();
};

// Global handler for unhandled promise rejections
const handleUnhandledRejection = (event) => {
  console.error('Unhandled promise rejection:', event.reason);

  // Show user-friendly error message
  triggerToast.error('A network or processing error occurred. Please try again.');

  // You can log to an error reporting service here
  // Example: logErrorToService(event.reason, { type: 'unhandled_rejection' });

  // Prevent the default browser handling
  event.preventDefault();
};

// Setup global error handlers
export const setupGlobalErrorHandlers = () => {
  // Handle uncaught JavaScript errors
  window.addEventListener('error', handleUncaughtError);

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
};

// Cleanup function to remove event listeners
export const cleanupGlobalErrorHandlers = () => {
  window.removeEventListener('error', handleUncaughtError);
  window.removeEventListener('unhandledrejection', handleUnhandledRejection);
};

// Manual error logging function for custom error reporting
export const logError = (error, context = {}) => {
  console.error('Manual error log:', error, context);

  // You can integrate with error reporting services here
  // Example: errorReportingService.log(error, context);
};
